// extracted by mini-css-extract-plugin
export default {"container":"container-rAMUW","title":"title-fbYAU","close":"close-XKQ6R","icon":"icon-vNGqV"};